
<template>
    <el-dialog title="提示" :visible.sync="talkdialog" width="30%" :before-close="close">
        <p class="talktitle">确认发送以下文件吗？</p>
        <div class="selcon" v-if="tdata.type==5">
            <div class="filecon">
                <b class="iconfont doc" v-if="tdata.data.st =='doc'">&#xe737;</b>
                <b class="iconfont xls" v-if="tdata.data.st =='xls'">&#xe732;</b>
                <b class="iconfont ppt" v-if="tdata.data.st =='ppt'">&#xe731;</b>
                <b class="iconfont pdf" v-if="tdata.data.st =='pdf'">&#xe733;</b>
                <p>{{tdata.data.fname}}</p>
                <span>{{tdata.data.fsize}}</span>
            </div>
        </div>

        <div class="selcon imgcon" v-if="tdata.type==2">
            <img :src="tdata.data.con" alt="">
        </div>

        <div class="selcon videocon" v-if="tdata.type==4">
            <video controls :src="tdata.data.con"></video>
        </div>

        <div class="selcon mp3con" v-if="tdata.type==3">
            <audiopaly bg="hui" :mp3url="tdata.data.con"></audiopaly>
        </div>


        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="send">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>
    import {
        mapGetters,
        mapMutations
    } from 'vuex'
    import {
        checkWeChatMsg
    } from '@/utils/api-im.js'
    import uploadfile from '@/utils/upload.js'
    import audiopaly from '@/components/mp3Play'
    export default {
        name: 'seltalk',
        data() {
            return {

            }
        },
        components:{
            audiopaly
        },
        props:{
            talkdialog:'',
            tdata:{}
        },
        computed: {
            ...mapGetters('im', [
                'selectfriendids',
            ])
        },
       mounted() {

        },

        methods: {
            ...mapMutations('im', [
                'MSGID',
            ]),

            send(){
                console.log(this.tdata)
                let contenttype = null
                let filecon = {}
                if(this.tdata.type == 2){
                    contenttype = 2
                    filecon = {
                        Thumb:this.tdata.data.con,
                        LinkUrl:this.tdata.data.con
                    }
                }
                if(this.tdata.type == 3){
                    contenttype = 3
                    filecon = {
                        Duration:this.tdata.data.st,
                        LinkUrl:this.tdata.data.con.split('://')[1],
                        Thumb:this.tdata.data.con
                    }
                }
                if(this.tdata.type == 4){
                    contenttype = 4
                    filecon = {
                        Thumb:this.tdata.data.con+"?x-oss-process=video/snapshot,t_0,m_fast",
                        LinkUrl:this.tdata.data.con
                    }
                }
                if(this.tdata.type == 5 ){
                    contenttype = 8
                    filecon = {
                        Title: this.tdata.data.fname,
                        // source:"云朵IM",
                        Type:6,
                        TypeStr:"[文件]",
                        Des:this.tdata.data.fsize+', '+this.tdata.data.st,
                        Thumb: this.tdata.data.con,
                        Url:this.tdata.data.con
                    }
                }
                console.log(filecon)
                let uuid = uploadfile.generateUUID()
                filecon = JSON.stringify(filecon)
                this.MSGID(uuid) //保存uuid
                console.log(filecon)
                this.$post(checkWeChatMsg, {
                    wechatid: this.selectfriendids.wechatContactinfo.wechatid,
                    friendid: this.selectfriendids.wechatContactinfo.friendid
                }).then(res => {
                    if(res.data.code ==200){
                        this.socketApi.sendSock({
                            msgType: "TALK_TO_FRIEND_REQ",
                            msgContent: {
                                weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                                friendId: this.selectfriendids.wechatContactinfo.friendid,
                                contentType: contenttype,
                                content: filecon,
                                sendUuid: uuid
                            }
                        })
                    }else{
                        this.$message.error(res.data.msg);
                    }

                    this.$emit('closetalk')
                })

            },

            close() {
                this.$emit('closetalk')
            },

            showtoast() {
                this.$toast('showtoast');
            },
        }
    };
</script>
<style lang="less" scoped>
    .talktitle{
        height:20px;
        font-size:14px;
        color:rgba(42,42,42,1);
        line-height:20px;
        margin-bottom: 20px;
    }
    .selcon {
        padding: 14px 26px 14px 22px;
        background: rgba(249, 250, 252, 1);
        border-radius: 3px;
        line-height: 22px;
        font-size: 12px;
        cursor: pointer;
        margin-bottom: 10px;

        &.mp3con{
            padding: 0;
            width: 390px;
            margin: 0 auto;
        }

        &.imgcon,&.videocon{
            padding: 0;
            background: #fff;
            overflow-y: auto;
            max-height: 450px;

            img,video{
                max-width: 100%;
            }

        }

        .txtcon {
            max-height: 68px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .filecon{
            padding-left: 46px;
            position: relative;

            b{
                position: absolute;
                top: 0;
                left: 0;
                font-size: 36px;
                height: 44px;
                line-height: 44px;
            }

            .doc{
                color: #5DACFF;
            }

            .xls{
                color: #5ACC9B;
            }

            .ppt{
                color: #FF8A76;
            }

            .pdf{
                color: #FF6969;
            }

            p{
                font-size: 14px;
                color: #2A2A2A;
            }

            span{
                font-size: 12px;
                color: #93999F;
            }
        }
    }


</style>
<style>
    .el-dialog {
        border-radius: 6px;
    }

</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/seltalk.vue